import classNames from "classnames"

type Props = {
  text: string,
  onClick?: () => void,
  active?: boolean,
  size?: 'small' | 'default',
}

const PersonalizationTag = ({
  text,
  onClick = () => {},
  active,
  size = 'default',
}: Props) => {
  return (
    <div
      onClick={onClick}
      className={classNames('wizard-label-btn cursor-pointer', { selected: active, [`size-${size}`]: size })}
    >{text}</div>
  )
}

export default PersonalizationTag
